<template>
  <div>
    <Selector
      :width="width"
      :height="height"
      :image="image"
      :markup="markup"
      :apartments="apartments"
      @apartmentSelected="handleApartmentClick"
      :config="config"
    >
      <slot name="selector"></slot>
    </Selector>
    <div class="container mt-4 md:mt-8 lg:mt-14 mb-5">
      <div class="block md:hidden border-b border-gray-300">
        <select
          v-model="activeFilter"
          class="bg-transparent p-3 w-full bg-accent-100"
        >
          <option
            v-for="filter in filters"
            :value="filter.value"
            :key="filter.label"
          >
            {{ filter.label }}
          </option>
        </select>
      </div>
      <div class="hidden md:flex items-center gap-3 relative">
        <div
          v-for="(filter, i) in filters"
          :key="i"
          @click="
            () => {
              activeFilter = filter.value;
            }
          "
          :class="[
            'pb-3 border-b-3 text-semibold cursor-pointer transition-colors',
            activeFilter === filter.value
              ? 'border-black'
              : 'border-transparent text-gray-600 hover:text-black',
          ]"
        >
          {{ filter.label }}
        </div>
        <div class="absolute bottom-0 w-full h-px bg-gray-300"></div>
      </div>
    </div>
    <div
      class="container gap-4 flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3"
    >
      <apartment-card
        v-for="apartment in filteredApartments.slice(0, this.limit)"
        :key="apartment.id"
        :apartment="apartment"
        :config="config"
        @apartmentSelected="handleApartmentClick"
      />
    </div>
    <div class="flex items-center justify-center">
      <button
        class="btn btn--clickable mt-10"
        v-if="limit < this.filteredApartments.length"
        @click="increaseLimit"
      >
        Pokaz więcej nieruchomości
      </button>
    </div>
    <popup
      :isVisible="popupVisible"
      :apartment="selected"
      :config="config"
      @closePopup="handlePopupClose"
    >
      <template v-slot:image>
        <slot name="image"></slot>
      </template>
      <template v-slot:form>
        <slot name="form"></slot>
      </template>
    </popup>
  </div>
</template>

<script>
import Selector from './partials/Selector.vue';
import Popup from './partials/Popup.vue';
import ApartmentCard from './partials/ApartmentCard.vue';
export default {
  props: {
    width: {
      type: [Number, String],
      default: 1800,
    },
    height: {
      type: [Number, String],
      default: 1080,
    },
    markup: {
      type: String,
    },
    sheet: {
      type: String,
      required: true,
    },
    sheetName: {
      type: String,
    },
    filter: {
      type: String,
    },
    phone: {
      type: String,
    },
    email: {
      type: String,
    },
    initialFilter: {
      type: String,
      default: 'all',
    },
    button: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  components: {
    Selector,
    Popup,
    ApartmentCard,
  },
  data() {
    return {
      activeFilter: this.initialFilter,
      apartments: [],
      filteredApartments: [],
      limit: 6,
      initialLimit: 6,
      filters: [],
      popupVisible: false,
      selected: null,
      config: {
        name: this.name,
        button: this.button,
        phone: this.phone,
        email: this.email,
      },
    };
  },
  beforeMount() {
    const apiKey = 'AIzaSyCRovlDDKFRgxNqvgN_jM_wsP4G8LbjQz0';
    fetch(
      'https://sheets.googleapis.com/v4/spreadsheets/' +
        this.sheet +
        '/values/' +
        this.sheetName +
        '?key=' +
        apiKey
    )
      .then((res) => res.json())
      .then((json) => {
        const reserved = ['id', 'status', 'price', 'download'];
        const keys = json.values[0];
        const values = json.values.slice(1);
        const filters = [{ label: 'Wszystko', value: 'all' }];
        const apartments = values.map((array) => {
          const object = {};
          const details = [];
          keys.forEach((key, i) => {
            if (this.filter && key === this.filter) {
              filters.push({
                label:
                  this.filter !== 'status'
                    ? `${this.filter} ${array[i]}`
                    : array[i],
                value: array[i],
              });
            }
            if (reserved.includes(key)) {
              object[key] = array[i];
            } else {
              object[key] = array[i];
              details.push({
                label: key,
                value: array[i],
              });
            }
          });

          object.details = details;
          return object;
        });
        this.filters = filters.filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.label === value.label && t.value === value.value
            )
        );
        this.apartments = apartments;
        this.filteredApartments = apartments;
        this.filterApartments();
      });
  },
  methods: {
    filterApartments() {
      console.log(this.status);
      let filterKey = this.filter;
      if (this.activeFilter !== 'all') {
        this.filteredApartments = this.apartments.filter(
          (apartment) => apartment[filterKey] === this.activeFilter
        );
      } else {
        this.filteredApartments = this.apartments;
      }
    },
    increaseLimit() {
      this.limit = this.limit + this.initialLimit;
      this.filterApartments();
    },
    handleApartmentClick(load) {
      this.popupVisible = true;
      this.selected = this.apartments.filter((item) => item.id == load)[0];
    },
    handlePopupClose() {
      this.popupVisible = false;
    },
  },
  computed: {
    computedFilters() {
      let filter = this.filter;
      return this.apartments.forEach((item) => {
        return item[filter];
      });
    },
  },
  watch: {
    activeFilter(prev, next) {
      if (prev !== next) this.filterApartments();
    },
    popupVisible(val) {
      if (val) {
        $('body').addClass('overflow-hidden');
      } else {
        $('body').removeClass('overflow-hidden');
      }
    },
  },
};
</script>
